import React from "react";

const SectionLabel = ({ children }) => (
  <div className="flex items-center gap-3">
    <span className="inline-block w-2.5 h-2.5 rounded-full border border-white/50" />
    <span className="font-mono-label text-[11px] text-white/55">{children}</span>
  </div>
);

export default SectionLabel;
